import React from "react";

export const GOLD = "#D4AF37";
export const GOLD_LIGHT = "#F3E5AB";
export const NAVY = "#121A2F";
export const PALETTE = ["#D4AF37", "#34D399", "#60A5FA", "#A78BFA", "#FB7185", "#F59E0B", "#22D3EE"];

export const tooltipStyle = {
    background: "#121A2F",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 8,
    color: "#F8FAFC",
    fontSize: 12,
};

export function formatTR(n) {
    if (n === null || n === undefined) return "—";
    return Number(n).toLocaleString("tr-TR");
}

export function formatCurrency(n) {
    if (n === null || n === undefined) return "—";
    return Number(n).toLocaleString("tr-TR", {
        style: "currency",
        currency: "TRY",
        maximumFractionDigits: 0,
    });
}

export function SectionLabel({ title, subtitle }) {
    return (
        <div className="mb-3 flex items-baseline justify-between">
            <div>
                <h2 className="font-display text-xl text-white tracking-tight">{title}</h2>
                {subtitle && <div className="text-xs text-slate-500 mt-0.5">{subtitle}</div>}
            </div>
            <div className="flex-1 ml-6 h-px bg-gradient-to-r from-white/10 via-white/5 to-transparent" />
        </div>
    );
}
